module.exports = __webpack_public_path__ + "img/6.e9d0821d.png";